export default
{
    components:
    {

    },

    props:
    {
        content: { type: Object, default: null },
        searchValue: { type: String, default: '' }
    },

    data()
    {
        return {
            category:
            {
                label: '',
                slug: ''
            },

            subCategory:
            {
                label: '',
                slug: ''
            },

            href: '',

            colorIndex: 0,

            test: [],

            title: ''
        }
    },

    mounted()
    {
        this.initCategory()
        this.initSubCategory()
        this.initHref()

        const pattern = new RegExp('(' + this.searchValue + ')', 'gi')

        this.title = this.content.post_title.replace(pattern, '<span class=\"c-page-search__list__item__title__search__letter is-active\">' + this.searchValue + '</span>')
    },

    methods:
    {
        initCategory()
        {
            if(this.content.post_type === 'instagram')
            {
                this.category.label = this.$root.trads[32]
                this.category.slug = 'medias'

                this.colorIndex = 2
            }
            else if(this.content.post_type === 'team')
            {
                this.category.label = this.$root.trads[30]
                this.category.slug = 'team'

                this.colorIndex = 3
            }
            else if(this.content.post_type === 'projects')
            {
                this.category.label = this.$root.trads[5]
                this.category.slug = 'projects'

                this.colorIndex = 0
            }
            else if(this.content.post_type === 'medias')
            {
                this.category.label = this.$root.trads[32]
                this.category.slug = 'medias'

                this.colorIndex = 2
            }
            else if(this.content.post_type === 'article')
            {
                this.category.label = this.$root.trads[31]
                this.category.slug = 'article'

                this.colorIndex = 1
            }
            else if(this.content.post_type === 'agency')
            {
                this.category.label = this.$root.trads[30]
                this.category.slug = 'agency'

                this.colorIndex = 3
            }
        },

        initSubCategory()
        {
            if(this.content.post_type === 'instagram')
            {
                this.subCategory.label = 'Instagram'
                this.subCategory.slug = 'instagram'
            }

            if(this.content.post_type === 'team')
            {
                this.subCategory.label = this.$root.trads[33]
                this.subCategory.slug = 'team'
            }
        },

        initHref()
        {
            if(this.content.post_type === 'instagram')
            {
                this.href = 'https://instagram.com' + this.content.post_content.match(/https:\/\/www.instagram.com(.*)\/["']/)[1]
            }
            else
            {
                const slug = this.content.post_type === 'team' ? '' : this.content.post_name
                this.href = this.content.post_type + '/' + slug
            }
        }
    }
}



// WEBPACK FOOTER //
// ./src/scripts/components/app-search-list-item/script.js